import { Component, OnInit, Inject } from '@angular/core';
import { BODY_REPORT_DAMAGE_DATA } from './body-report-damage.tokens';
import { BodyReportDamageOverlayRef } from './body-report-damage-ref';
import { Observable } from 'rxjs';
import { MediaStateService } from '@quorum/sha-media';
import { InspectionService } from '../inspection.service';
import { BrowserControlCommunicationService } from '@applications/sha-services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'quorum-body-report-damage',
  templateUrl: './body-report-damage.component.html',
  styleUrls: ['./body-report-damage.component.css'],
})
export class BodyReportDamageComponent implements OnInit {
  mediaParams$: Observable<any>;
  constructor(
    @Inject(BODY_REPORT_DAMAGE_DATA) public selectedElement: any,
    public dialogRef: BodyReportDamageOverlayRef,
    public mediaStateService: MediaStateService,
    public inspectionService: InspectionService,
    public route: ActivatedRoute,
    private browserControlService: BrowserControlCommunicationService
  ) {}

  ngOnInit(): void {
    this.mediaParams$ = this.browserControlService.embeddedInXsellerator
      ? this.mediaStateService.getMediaParamsForKey('inspection')
      : this.mediaStateService.getMediaParamsForKey('bodyReport');
  }

  formatSeverity(selectedElement: any) {
    let retVal: string = '';
    switch (selectedElement.severity) {
      case 1:
        retVal = `(Superficial ${selectedElement.type})`;
        break;
      case 2:
        retVal = `(Minor ${selectedElement.type})`;
        break;
      case 3:
        retVal = `(Major ${selectedElement.type})`;
        break;
    }
    return retVal;
  }

  delete(element: any) {
    this.dialogRef.delete();
  }

  close() {
    this.dialogRef.close();
  }

  cancel() {
    this.dialogRef.cancel();
  }
}
